

{
  "familyId": "GET-ROND-BASIS",
  "questions": [
    {
      "id": "GET-ROND-BASIS-001",
      "familyId": "GET-ROND-BASIS",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "afronden_tientallen_honderdtallen",
      "questionType": "fill_in",
      "question": "De school heeft 47 stoelen besteld. De leverancier rondt af op tientallen. Hoeveel stoelen schrijft hij op?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["50"],
        "caseSensitive": false,
        "placeholder": "afgerond getal"
      },
      "pedagogy": { "dok": 1 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden op tientallen",
            "content": "Kijk naar het eenheidscijfer. Is het 5 of hoger? Rond dan omhoog naar het volgende tiental. Is het lager dan 5? Rond dan omlaag naar het vorige tiental.",
            "icon": "lightbulb"
          }
        },
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 40,
            "end": 50,
            "marked": [47],
            "step": 1,
            "label": "47 ligt dichter bij 50 dan bij 40"
          }
        }
      ],
      "conceptId": "round_tens_up",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Bij afronden op tientallen kijk je naar het eenheidscijfer. In 47 is het eenheidscijfer 7. De afrondregel zegt: 7 ≥ 5, dus je rondt omhoog af. 47 → 50.",
        "solutionSteps": [
          "Kijk naar het eenheidscijfer: de 7 in 47",
          "Is 7 gelijk aan of groter dan 5? Ja",
          "Rond omhoog af: 47 → 50",
          "Check: 50 is een veelvoud van 10 ✓"
        ]
      }
    },
    {
      "id": "GET-ROND-BASIS-002",
      "familyId": "GET-ROND-BASIS",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "afronden_tientallen_honderdtallen",
      "questionType": "fill_in",
      "question": "In de klas liggen 83 boeken op de plank. De juf rondt af op tientallen voor haar lijst. Welk getal schrijft ze op?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["80"],
        "caseSensitive": false,
        "placeholder": "afgerond getal"
      },
      "pedagogy": { "dok": 1 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden op tientallen",
            "content": "Kijk naar het eenheidscijfer. In 83 is dat de 3. Is 3 < 5? Ja → rond omlaag af: 83 → 80.",
            "icon": "lightbulb"
          }
        },
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 80,
            "end": 90,
            "marked": [83],
            "step": 1,
            "label": "83 ligt dichter bij 80 dan bij 90"
          }
        }
      ],
      "conceptId": "round_tens_down",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "In 83 is het eenheidscijfer 3. De afrondregel: 3 < 5 → rond omlaag af. 83 → 80.",
        "solutionSteps": [
          "Kijk naar het eenheidscijfer: de 3 in 83",
          "Is 3 kleiner dan 5? Ja",
          "Rond omlaag af: 83 → 80",
          "Check: 80 is een veelvoud van 10 ✓"
        ]
      }
    },
    {
      "id": "GET-ROND-BASIS-003",
      "familyId": "GET-ROND-BASIS",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "afronden_tientallen_honderdtallen",
      "questionType": "multiple_choice",
      "question": "Op een schoolfeest zijn 65 leerlingen. De directeur rondt af op tientallen. Welk getal schrijft hij op?",
      "context": null,
      "options": ["70", "60", "65", "75"],
      "correctAnswer": 0,
      "pedagogy": { "dok": 1 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden bij eenheidscijfer 5",
            "content": "Als het eenheidscijfer precies 5 is, ronden we altijd omhoog. Dit is de standaard afrondregel in Nederland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "round_tens_five",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Het eenheidscijfer is precies 5. De afrondregel: bij 5 of hoger rond je altijd omhoog af. 65 → 70. Dit is een afspraak — bij precies 5 ga je altijd omhoog.",
        "solutionSteps": [
          "Kijk naar het eenheidscijfer: de 5 in 65",
          "Is 5 gelijk aan of groter dan 5? Ja",
          "Afspraak: bij precies 5 altijd omhoog",
          "Rond omhoog af: 65 → 70"
        ],
        "distractorExplanations": {
          "0": "Goed! Eenheidscijfer 5 → altijd omhoog afronden → 65 → 70.",
          "1": "60 is fout. Bij een eenheidscijfer van 5 ronden we altijd omhoog. Dus 65 → 70, niet 60.",
          "2": "65 is het getal zelf — je hebt niet afgerond. Bij tientallen is het antwoord altijd een veelvoud van 10.",
          "3": "75 is geen tiental. Je hebt 10 opgeteld in plaats van afgerond. Het dichtstbijzijnde tiental boven 65 is 70."
        }
      }
    },
    {
      "id": "GET-ROND-BASIS-004",
      "familyId": "GET-ROND-BASIS",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "afronden_tientallen_honderdtallen",
      "questionType": "fill_in",
      "question": "Een winkel heeft 347 pakken melk verkocht. De eigenaar rondt af op honderdtallen. Welk getal schrijft hij op?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["300"],
        "caseSensitive": false,
        "placeholder": "afgerond getal"
      },
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden op honderdtallen",
            "content": "Kijk naar het tientalcijfer (het middelste cijfer). In 347 is dat de 4. Is 4 < 5? Ja → rond omlaag af: 347 → 300. Let op: je kijkt naar het tientalcijfer (4), niet naar het eenheidscijfer (7)!",
            "icon": "lightbulb"
          }
        },
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 300,
            "end": 400,
            "marked": [347],
            "step": 10,
            "label": "347 ligt dichter bij 300 dan bij 400"
          }
        }
      ],
      "conceptId": "round_hundreds_down",
      "variantIndex": 4,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Bij honderdtallen kijk je naar het tientalcijfer. In 347 is dat de 4. Pas op: niet naar de 7 kijken! 4 < 5 → omlaag: 347 → 300.",
        "solutionSteps": [
          "Kijk naar het tientalcijfer: de 4 in 347",
          "Is 4 kleiner dan 5? Ja",
          "Rond omlaag af: 347 → 300",
          "Check: 300 is een veelvoud van 100 ✓"
        ]
      }
    },
    {
      "id": "GET-ROND-BASIS-005",
      "familyId": "GET-ROND-BASIS",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "afronden_tientallen_honderdtallen",
      "questionType": "multiple_choice",
      "question": "Een school heeft 782 leerlingen. De gemeente rondt af op honderdtallen. Welk getal staat in het rapport?",
      "context": null,
      "options": ["800", "700", "780", "790"],
      "correctAnswer": 0,
      "pedagogy": { "dok": 1 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden op honderdtallen",
            "content": "Kijk naar het tientalcijfer. In 782 is dat de 8. Is 8 ≥ 5? Ja → rond omhoog af: 782 → 800.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "round_hundreds_up",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "get.afronden-richting-fout", "label": "Verkeerd geafrond (omlaag i.p.v. omhoog)", "optionIndex": 1 },
          { "id": "get.afronden-naar-tiental-ipv-honderdtal", "label": "Afgerond op tientallen i.p.v. honderdtallen", "optionIndex": 2 },
          { "id": "get.afronden-naar-tiental-ipv-honderdtal", "label": "Afgerond op tientallen i.p.v. honderdtallen", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "In 782 is het tientalcijfer 8. De afrondregel: 8 ≥ 5 → omhoog. 782 → 800.",
        "solutionSteps": [
          "Kijk naar het tientalcijfer: de 8 in 782",
          "Is 8 gelijk aan of groter dan 5? Ja",
          "Rond omhoog af: 782 → 800",
          "Check: 800 is een veelvoud van 100 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Tientalcijfer 8 (≥ 5) → omhoog afronden: 782 → 800.",
          "1": "700 is fout. Het tientalcijfer is 8 (≥ 5), dus je rondt omhoog af: 782 → 800.",
          "2": "780 is een tiental, geen honderdtal. Bij honderdtallen is het antwoord altijd een veelvoud van 100.",
          "3": "790 is ook een tiental. Het antwoord moet een veelvoud van 100 zijn: 700 of 800."
        }
      }
    },
    {
      "id": "GET-ROND-BASIS-006",
      "familyId": "GET-ROND-BASIS",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "afronden_tientallen_honderdtallen",
      "questionType": "multiple_choice",
      "question": "Een sportvereniging heeft 550 leden. De voorzitter rondt af op honderdtallen. Welk getal schrijft hij op?",
      "context": null,
      "options": ["600", "500", "550", "560"],
      "correctAnswer": 0,
      "pedagogy": { "dok": 1 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden bij tientalcijfer 5",
            "content": "Als het tientalcijfer precies 5 is, ronden we altijd omhoog naar het volgende honderdtal. 550 → 600.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "round_hundreds_fifty",
      "variantIndex": 6,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "get.afronden-bij-5-omlaag", "label": "Bij 5 omlaag geafrond i.p.v. omhoog", "optionIndex": 1 },
          { "id": "get.afronden-niet-toegepast", "label": "Niet afgerond — getal ongewijzigd", "optionIndex": 2 },
          { "id": "get.afronden-naar-tiental-ipv-honderdtal", "label": "Afgerond op tientallen i.p.v. honderdtallen", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "In 550 is het tientalcijfer 5. De afrondregel: bij 5 of hoger altijd omhoog. 550 → 600.",
        "solutionSteps": [
          "Kijk naar het tientalcijfer: de 5 in 550",
          "Is 5 gelijk aan of groter dan 5? Ja",
          "Afspraak: bij precies 5 altijd omhoog",
          "Rond omhoog af: 550 → 600"
        ],
        "distractorExplanations": {
          "0": "Goed! Tientalcijfer 5 → altijd omhoog afronden → 550 → 600.",
          "1": "500 is fout. Bij een tientalcijfer van 5 ronden we altijd omhoog: 550 → 600.",
          "2": "550 is het getal zelf — je hebt niet afgerond. Het antwoord moet een veelvoud van 100 zijn.",
          "3": "560 is een tiental, geen honderdtal. Het antwoord moet een veelvoud van 100 zijn: 500 of 600."
        }
      }
    },
    {
      "id": "GET-ROND-BASIS-007",
      "familyId": "GET-ROND-BASIS",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "afronden_tientallen_honderdtallen",
      "questionType": "true_false_series",
      "question": "Welke afrondingen zijn juist? Beoordeel elke bewering.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "156 afgerond op tientallen = 160", "isTrue": true, "explanation": "Eenheidscijfer 6 ≥ 5 → omhoog: 156 → 160 ✓" },
          { "text": "423 afgerond op honderdtallen = 500", "isTrue": false, "explanation": "Tientalcijfer 2 < 5 → omlaag: 423 → 400, niet 500" },
          { "text": "875 afgerond op tientallen = 880", "isTrue": true, "explanation": "Eenheidscijfer 5 → altijd omhoog: 875 → 880 ✓" },
          { "text": "649 afgerond op honderdtallen = 600", "isTrue": false, "explanation": "Tientalcijfer 4 < 5 → omlaag: 649 → 600. Wacht — dat klopt! Maar let op: het tientalcijfer is 4, dus 649 → 600 is juist." }
        ]
      },
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afrondregels",
            "content": "Tientallen: kijk naar het eenheidscijfer. Honderdtallen: kijk naar het tientalcijfer. Bij 5 of hoger → omhoog. Bij lager dan 5 → omlaag.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "round_mixed_judge",
      "variantIndex": 7,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Bij afronden moet je goed opletten welk cijfer je bekijkt. Bij tientallen kijk je naar het eenheidscijfer, bij honderdtallen naar het tientalcijfer. Pas op dat je niet het verkeerde cijfer pakt!",
        "solutionSteps": [
          "156 op tientallen: eenheidscijfer 6 ≥ 5 → 160 ✓",
          "423 op honderdtallen: tientalcijfer 2 < 5 → 400, niet 500 ✗",
          "875 op tientallen: eenheidscijfer 5 → omhoog → 880 ✓",
          "649 op honderdtallen: tientalcijfer 4 < 5 → 600 ✓"
        ]
      }
    },
    {
      "id": "GET-ROND-BASIS-008",
      "familyId": "GET-ROND-BASIS",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "afronden_tientallen_honderdtallen",
      "questionType": "fill_in",
      "question": "Rond 423 af op honderdtallen. Typ het afgeronde getal.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["400"],
        "caseSensitive": false,
        "placeholder": "afgerond getal"
      },
      "pedagogy": { "dok": 2 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden op honderdtallen",
            "content": "Kijk naar het tientalcijfer (het middelste cijfer). In 423 is dat de 2. Is 2 < 5? Ja → rond omlaag af: 423 → 400. Let op: niet naar de 3 kijken!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "round_hundreds_down_fill",
      "variantIndex": 8,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Bij honderdtallen kijk je naar het tientalcijfer. In 423 is dat de 2. 2 < 5 → omlaag: 423 → 400.",
        "solutionSteps": [
          "Kijk naar het tientalcijfer: de 2 in 423",
          "Is 2 kleiner dan 5? Ja",
          "Rond omlaag af: 423 → 400"
        ]
      }
    },
    {
      "id": "GET-ROND-BASIS-009",
      "familyId": "GET-ROND-BASIS",
      "module": "Getalbegrip",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "afronden_tientallen_honderdtallen",
      "questionType": "fill_in",
      "question": "Op de markt zijn 875 bezoekers. Rond af op tientallen. Typ het afgeronde getal.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["880"],
        "caseSensitive": false,
        "placeholder": "afgerond getal"
      },
      "pedagogy": { "dok": 1 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afronden bij eenheidscijfer 5",
            "content": "In 875 is het eenheidscijfer 5. Bij 5 of hoger rond je altijd omhoog af: 875 → 880.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "round_tens_five_fill",
      "variantIndex": 9,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "In 875 is het eenheidscijfer 5. De afrondregel: bij 5 of hoger altijd omhoog. 875 → 880.",
        "solutionSteps": [
          "Kijk naar het eenheidscijfer: de 5 in 875",
          "Is 5 gelijk aan of groter dan 5? Ja",
          "Rond omhoog af: 875 → 880"
        ]
      }
    }
  ]
}

